import { z } from 'zod';

export const DocumentTypeSchema = z.enum([
  'fattura',
  'ddt',
  'nota_credito',
  'nota_debito',
  'autofattura',
]);
export type DocumentType = z.infer<typeof DocumentTypeSchema>;

export const SdiStatusSchema = z.enum([
  'received',
  'parsed',
  'matched',
  'reconciled',
  'rejected',
  'ocr_pending',
  'ocr_failed',
]);
export type SdiStatus = z.infer<typeof SdiStatusSchema>;

export const DocumentSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid().nullable(),
  supplier_id: z.string().uuid().nullable(),
  type: DocumentTypeSchema,
  number: z.string().max(50),
  date: z.string().date(),
  total_amount: z.number(),
  currency: z.string().length(3).default('EUR'),
  sdi_id: z.string().nullable(),
  received_via_provider: z.string().nullable(),
  xml_file_id: z.string().nullable(),
  pdf_file_id: z.string().nullable(),
  image_file_id: z.string().nullable(),
  parsed_at: z.string().datetime().nullable(),
  status: SdiStatusSchema,
  audit_hash: z.string().length(64).nullable(),
  retention_until: z.string().date(),
  notes: z.string().nullable(),
  created_at: z.string().datetime(),
});
export type Document = z.infer<typeof DocumentSchema>;

export const DocumentLineSchema = z.object({
  doc_id: z.string().uuid(),
  seq: z.number().int().positive(),
  description: z.string().max(500),
  food_id: z.string().uuid().nullable(),
  qty: z.number(),
  uom: z.string().max(10),
  unit_price: z.number().nullable(),
  line_total: z.number().nullable(),
  batch_lot: z.string().nullable(),
  expiration_date: z.string().date().nullable(),
  iva_rate: z.number().nullable(),
});
export type DocumentLine = z.infer<typeof DocumentLineSchema>;
